export const locale_en =
    {
        dashboard: 'Dashboard',
        work_shifts: 'Reports',
        projects: 'Projects',
        clients: 'Clients',
        workers: 'Workers',
        profile: 'Profile',
        areas: 'Areas',
        countries: 'Countries',
        cities: 'Cities',
        postal_codes: 'Postal Codes',
        my_profile: 'My profile',
        logout: 'Logout',
        pick_a_week: 'Pick a week',
        start_date: 'Start date',
        end_date: 'End date',
        print: 'Print',
        export_excel: 'Export Excel',
        start: 'Start',
        stop: 'Stop',
        total: 'Total',
        project_name: 'Project Name',
        client: 'Client',
        worker: 'Worker',
        project_manager: 'Project Manager',
        total_hours: 'Total working hours',
        project_description: 'Project description',
        project_address: 'Project address',
        planned_start_date: 'Planned start date',
        add_project: 'Add project',
        update_project: 'Update project',
        select_client: "Select client",
        select_project_manager: 'Select project manager',
        select_worker: 'Select worker',
        select_planned_start_date: 'Select planned start date',
        address_line1: 'Address Line 1',
        address_line2: 'Address Line 2',
        select_country: 'Select country',
        select_city: 'Select city',
        select_postal_code: 'Select Postal Code',
        add_client: 'Add client',
        client_address: 'Client address',
        update_client: 'Update client',
        client_name: 'Client name',
        registered_no: 'Registered No',
        email: 'Email',
        phone: 'Phone',
        first_name: 'First name',
        client_workers: 'Client Workers',
        add_worker: 'Add worker',
        update_worker: 'Update worker',
        last_name: 'Last name',
        personal_no: 'Personal No',
        add_user: 'Add user',
        update_user: 'Update user',
        login: 'Login',
        password: 'Password',
        password_confirmation: 'Password confirmation',
        edit_company_profile: 'Edit Company Profile',
        name: 'Name',
        submit: 'Submit',
        add_country: 'Add country',
        update_country: 'Update country',
        country_name: 'Country name',
        id: 'ID',
        add_city: 'Add city',
        update_city: 'Update city',
        city_name: 'City name',
        add_postal_code: 'Add postal code',
        postal_code: 'Postal Code',
        update_postal_code: 'Update postal code',
        postal_code_value: 'Postal code value',
        actions: 'Actions',
        add_work_unit: 'Add work unit',
        update_work_unit: 'Update work unit',
        select_project: 'Select project',
        select_date: 'Select date',
        select_start: 'Select start',
        select_stop: 'Select stop',
        project_managers: 'Project Managers',
        address: 'Address',
        fill_all_required_fields: 'Fill all required fields',
        user: 'user',
        project: 'project',
        to_add: 'to add',
        to_update: 'to update',
        change_password: 'Change Password',
        region: 'Region',
        work_unit: 'work unit',
        please_enter_a_valid_address: 'Please enter a valid address',
        Validate_address: 'Validate address',
        is_not_valid: 'is not valid',
        coordinates: 'Coordinates',
        employment_number: 'Employment number',
        client_project_number: 'Client`s project number',
        own_project_number: 'Own project number',
        is_not_unique: 'is not unique',
        status: 'Status',
        company: 'Company',
        date: 'Date',
        i_dont_remember_my_login: 'I do not remember my login',
        get_back: 'Get Back',
        check_spam: 'If you didn`t receive an email, please check your spam folder',
        password_changed: 'Password changed successfully',
        check_email: 'Check your email please',
        daily_report: 'Daily report',
        send: 'Send',
        description: 'Description',
        access_groups: 'Access group',
        companies: "Companies",
        add_company: "Add company",
        company_name: "Company name",
        registered_num: "Registered number",
        company_address: "Company address",
        website: "Website",
        update_company: "Update company",
        Address:"Address",
        Role:"Role",
        First_Name:"First name",
        Second_Name:"Second name",
        Org_nummer: 'Registered No',
        Calendar:'Calendar',
        Weekends:'Weekend',
        Days_off: 'Days off',
        Timesheet: "Timesheet",
        Days_of_the_week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        Report_date : 'Report date',
        Sample_period: 'Sample period',
        Worker_report : "Worker's report",
        Project_report : "Project's report",
        Client_report: "Client's report",
    };